import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_3 = {
  key: 1,
  class: "settings-card"
}
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "freq-options" }
const _hoisted_7 = {
  key: 0,
  class: "settings-meta"
}
const _hoisted_8 = {
  key: 1,
  class: "form-error"
}
const _hoisted_9 = { class: "form-actions" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tab-head" }, [
      _createElementVNode("h2", { class: "tab-title" }, "Gerenciar Escritório")
    ], -1)),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "settings-title" }, "Encaminhamento de Requisições de Compra", -1)),
          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "settings-desc" }, " As requisições de compra são enviadas em planilha Excel para o email configurado abaixo, conforme a frequência escolhida. ", -1)),
          _createElementVNode("label", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "field-label" }, "Email de destino", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "field-input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.forwardEmail) = $event)),
              type: "email",
              placeholder: "compras@empresa.com.br"
            }, null, 512), [
              [_vModelText, _ctx.forwardEmail]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "field-label" }, "Frequência de envio", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                class: _normalizeClass(["freq-option", { active: _ctx.forwardFrequency === 'sempre' }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  value: "sempre",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.forwardFrequency) = $event)),
                  class: "sr-only"
                }, null, 512), [
                  [_vModelRadio, _ctx.forwardFrequency]
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "freq-name" }, "Sempre", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "freq-desc" }, "Sempre que uma nova requisição for solicitada", -1))
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["freq-option", { active: _ctx.forwardFrequency === 'diario' }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  value: "diario",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.forwardFrequency) = $event)),
                  class: "sr-only"
                }, null, 512), [
                  [_vModelRadio, _ctx.forwardFrequency]
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "freq-name" }, "Diariamente", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "freq-desc" }, "Resumo diário com as requisições novas", -1))
              ], 2),
              _createElementVNode("label", {
                class: _normalizeClass(["freq-option", { active: _ctx.forwardFrequency === 'semanal' }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  value: "semanal",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.forwardFrequency) = $event)),
                  class: "sr-only"
                }, null, 512), [
                  [_vModelRadio, _ctx.forwardFrequency]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "freq-name" }, "Semanalmente", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "freq-desc" }, "Resumo semanal com as requisições novas", -1))
              ], 2)
            ])
          ]),
          (_ctx.lastForwardAt)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Último envio: " + _toDisplayString(_ctx.formatDateTime(_ctx.lastForwardAt)), 1))
            : _createCommentVNode("", true),
          (_ctx.formError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.formError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn-save",
              type: "button",
              disabled: _ctx.saving,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar'), 9, _hoisted_10)
          ])
        ]))
  ]))
}